module.exports = __webpack_public_path__ + "media/country_flags/at-73bc4784.png";